import { render, staticRenderFns } from "./BookingCancelFeePop.vue?vue&type=template&id=3797d580&scoped=true"
import script from "./BookingCancelFeePop.vue?vue&type=script&lang=js"
export * from "./BookingCancelFeePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3797d580",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3797d580')) {
      api.createRecord('3797d580', component.options)
    } else {
      api.reload('3797d580', component.options)
    }
    module.hot.accept("./BookingCancelFeePop.vue?vue&type=template&id=3797d580&scoped=true", function () {
      api.rerender('3797d580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BookingCancelFeePop.vue"
export default component.exports